import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33e77dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outer-sphere" }
const _hoisted_2 = { class: "horizontal-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_count_down = _resolveComponent("count-down")!
  const _component_headline = _resolveComponent("headline")!
  const _component_seckill_goods = _resolveComponent("seckill-goods")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.seckillList.dataList && $setup.seckillList.dataList.length > 0)
      ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_headline, {
              title: $setup.tltleImgs,
              more: true,
              size: "18",
              colors: "#000",
              skipPath: "/flashSale"
            }, {
              center: _withCtx(() => [
                _createVNode(_component_count_down, {
                  timestamp: $setup.flash_sale_times_arr,
                  doesList: $setup.doesList.list,
                  havebegun: $setup.havebegun
                }, null, 8, ["timestamp", "doesList", "havebegun"])
              ]),
              _: 1
            }, 8, ["title"]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.seckillList.dataList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "crosswise",
                  key: item.goods_id
                }, [
                  _createVNode(_component_seckill_goods, { data: item }, null, 8, ["data"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}